module.exports = __webpack_public_path__ + "img/cursor.60242768.svg";